import BossModeAccounts from './BossModeAccounts.component';

export default BossModeAccounts;